import { getData } from '../util'
import axios from 'axios'
import { getAccessToken } from '../../utils'

/**
 * 获取pgc店铺添加管理员的二维码信息
 * @param liveroom_id
 * @return {Promise<*>}
 */
export async function getPgcInviteInfo(liveroom_id) {
    return getData(
        await axios.get(`/api/liveroom/${liveroom_id}/manager/pgc_invite_info`, {
            params: {
                token: getAccessToken(),
            },
        }),
    )
}



// WEBPACK FOOTER //
// ./src/api/module/manage.js